import React from "react";
import { FaFacebookF, FaInstagram, FaXTwitter, FaTiktok, FaYoutube, FaLinkedinIn, FaSnapchat, FaPinterestP } from "react-icons/fa6";

export const SOCIAL_PLATFORMS = [
  { key: "facebook", label: "Facebook", Icon: FaFacebookF, color: "#1877F2", placeholder: "username", url: (h) => `https://facebook.com/${h}` },
  { key: "instagram", label: "Instagram", Icon: FaInstagram, color: "#E4405F", placeholder: "username", url: (h) => `https://instagram.com/${h}` },
  { key: "x", label: "X", Icon: FaXTwitter, color: "#0F0F0F", placeholder: "username", url: (h) => `https://x.com/${h}` },
  { key: "tiktok", label: "TikTok", Icon: FaTiktok, color: "#0F0F0F", placeholder: "username", url: (h) => `https://tiktok.com/@${h}` },
  { key: "youtube", label: "YouTube", Icon: FaYoutube, color: "#FF0000", placeholder: "@channel", url: (h) => `https://youtube.com/@${h}` },
  { key: "linkedin", label: "LinkedIn", Icon: FaLinkedinIn, color: "#0A66C2", placeholder: "username", url: (h) => `https://linkedin.com/in/${h}` },
  { key: "snapchat", label: "Snapchat", Icon: FaSnapchat, color: "#C9A800", placeholder: "username", url: (h) => `https://snapchat.com/add/${h}` },
  { key: "pinterest", label: "Pinterest", Icon: FaPinterestP, color: "#BD081C", placeholder: "username", url: (h) => `https://pinterest.com/${h}` },
];

// tone: "light" (on light bg, beige circle + brand color) | "onHero" (over photo, frosted white circle + white icon)
// size: "sm" | "md"
export default function SocialLinks({ socials, legacy, label = "Socials", tone = "light", size = "md", className = "", testId = "profile-socials" }) {
  const entries = SOCIAL_PLATFORMS.filter((p) => socials && socials[p.key]);
  const legacyLinks = (legacy || []).filter(Boolean);
  if (entries.length === 0 && legacyLinks.length === 0) return null;

  const dim = size === "sm" ? "w-7 h-7" : "w-9 h-9";
  const iconDim = size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4";
  const circle = tone === "onHero"
    ? "bg-white/20 hover:bg-white/35 backdrop-blur-sm"
    : "bg-[#F0EBE1] hover:bg-[#E5E0D8]";

  return (
    <div className={className} data-testid={testId}>
      {label && tone !== "onHero" && (
        <p className="text-xs uppercase tracking-[0.14em] text-[#8A8A8A] mb-2">{label}</p>
      )}
      {entries.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2">
          {entries.map(({ key, label, Icon, color, url }) => (
            <a
              key={key}
              href={url(socials[key].replace(/^@/, ""))}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
              title={`${label}: @${socials[key].replace(/^@/, "")}`}
              data-testid={`${testId.replace("socials", "social")}-${key}`}
              className={`${dim} flex items-center justify-center rounded-full transition-all hover:-translate-y-0.5 ${circle}`}
            >
              <Icon style={tone === "onHero" ? { color: "#FFFFFF" } : { color }} className={iconDim}/>
            </a>
          ))}
        </div>
      )}
      {legacyLinks.length > 0 && tone !== "onHero" && (
        <p className="text-sm text-[#5C5C5C]" data-testid="profile-socials-legacy">{legacyLinks.join(", ")}</p>
      )}
    </div>
  );
}
